module.exports = __webpack_public_path__ + "img/clue3.bde9bfd7.png";